import { SHOW_ALL_TODOS } from '../constants/constants';

export default {
	todos: [],
	todosFilter: SHOW_ALL_TODOS,
};
